import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import type { ShopifyProduct } from "@/lib/shopify";

const storage = createJSONStorage(() =>
  typeof window !== "undefined"
    ? localStorage
    : {
        getItem: () => null,
        setItem: () => undefined,
        removeItem: () => undefined,
      },
);

export const COMPARE_LIMIT = 3;

interface CompareStore {
  items: ShopifyProduct[];
  isOpen: boolean;
  toggle: (product: ShopifyProduct) => void;
  remove: (id: string) => void;
  clear: () => void;
  setOpen: (open: boolean) => void;
  has: (id: string) => boolean;
}

export const useCompareStore = create<CompareStore>()(
  persist(
    (set, get) => ({
      items: [],
      isOpen: false,
      toggle: (product) => {
        const items = get().items;
        const exists = items.some((p) => p.node.id === product.node.id);
        if (exists) {
          set({ items: items.filter((p) => p.node.id !== product.node.id) });
        } else {
          if (items.length >= COMPARE_LIMIT) return;
          set({ items: [...items, product], isOpen: true });
        }
      },
      remove: (id) =>
        set({ items: get().items.filter((p) => p.node.id !== id) }),
      clear: () => set({ items: [], isOpen: false }),
      setOpen: (open) => set({ isOpen: open }),
      has: (id) => get().items.some((p) => p.node.id === id),
    }),
    {
      name: "howden-compare",
      storage,
      partialize: (s) => ({ items: s.items }),
    },
  ),
);
